import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import HelpPanel from '../../components/Help/HelpPanel'
import styles from '../../components/Help/Help.module.scss'

// Public page: also opened in the iOS and Android apps. ?platform=ios&context=dialer
const HelpPage = () => {
  const { slug } = useParams()
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const platform = params.get('platform') || undefined
  const context = params.get('context') || undefined

  const handleSlugChange = (value) => {
    const query = params.toString()
    navigate({ pathname: value ? `/help/${value}` : '/help', search: query ? `?${query}` : '' })
  }

  return (
    <div className={styles.pageWrapper}>
      <h1 className={styles.pageTitle}>Help</h1>
      <HelpPanel
        platform={platform}
        context={context}
        slug={slug}
        onSlugChange={handleSlugChange}
      />
    </div>
  )
}

export default HelpPage
